import { render, staticRenderFns } from "./sortingInfo.vue?vue&type=template&id=4188b974&scoped=true"
import script from "./sortingInfo.vue?vue&type=script&lang=js"
export * from "./sortingInfo.vue?vue&type=script&lang=js"
import style0 from "./sortingInfo.vue?vue&type=style&index=0&id=4188b974&prod&lang=less&scoped=true"
import style1 from "./sortingInfo.vue?vue&type=style&index=1&id=4188b974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188b974",
  null
  
)

export default component.exports